/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type of ImageBuild condition.
 */
export enum ImageBuildConditionType {
  ImageBuildConditionTypeReady = 'Ready',
}
